<template>
  <div class="container-info">
    <div class="disable-cover" v-if="orderStatus === OrderDeleted" />
    <basic-form
      ref="infoForm"
      title="Container Info"
      :mode="FormModes.SPARSE"
      :form-params="whatToShow"
    >
      <template v-slot:actions>
        <el-button
          size="small"
          type="primary"
          plain
          :disabled="orderStatus === OrderDeleted"
          @click="editing = true"
          v-if="enableEdit && !editing"
        >
          Edit
        </el-button>
        <el-button
          size="small"
          type="primary"
          plain
          @click="saveInfo"
          v-if="editing"
        >
          Save
        </el-button>
        <el-button
          size="small"
          type="danger"
          plain
          @click="editing = false"
          v-if="editing"
        >
          Cancel
        </el-button>
      </template>
    </basic-form>
  </div>
</template>
<script>
// others
import cloneDeep from 'lodash/cloneDeep'
import { FormModes } from '@/core/configs/types'
// msg
import PagesMessage from '@/core/message/pages'
// apis
import { updateContainer } from '@/api/container'
// models
import {
  ContainerInfoModifyForm,
  ContainerInfoWrapUp,
  ContainerModifyCheck
} from '@/core/models/container'
// components
import BasicForm from '@/components/common/BasicForm.vue'
import { OrderCreated, OrderDeleted } from '@/core/models/order'
export default {
  name: 'ContainerInfo',
  components: {
    BasicForm
  },
  props: {
    orderStatus: {
      type: String,
      default: OrderCreated
    },
    containerId: {
      type: String,
      required: true
    },
    container: {
      type: Object,
      default: null
    },
    enableEdit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      FormModes,
      OrderDeleted,
      loadingContainerInfo: false,
      editing: false
    }
  },
  computed: {
    whatToShow() {
      return this.editing ? this.editInfo : this.viewInfo
    },
    viewInfo() {
      const a = ContainerInfoWrapUp(this.container)
      return a
    },
    editInfo() {
      const form = cloneDeep(ContainerInfoModifyForm)
      Object.values(form).forEach(one => {
        one.value = this.container[one.key]
      })
      return form
    }
  },
  methods: {
    saveInfo() {
      const [formPassed, containerInfo] =
        this.$refs.infoForm.validateAllInputs()
      if (formPassed) {
        const { passed, hintMsgs, errMsg } = ContainerModifyCheck(containerInfo)
        const h = this.$createElement
        const displayedMsg = passed
          ? h(
            'div',
            null,
            hintMsgs.map(one => h('div', null, one))
          )
          : errMsg
        this.$confirm(displayedMsg, passed ? 'Warning' : 'Error', {
          showCancelButton: false,
          confirmButtonText: 'OK',
          type: passed ? 'warning' : 'error'
        })
          .then(() => {
            if (passed) {
              updateContainer(this.containerId, containerInfo).then(res => {
                if (res) {
                  this.editing = false
                  PagesMessage.emit(PagesMessage.eventMap.REFRESH_ORDER_DETAIL)
                }
              })
            }
          })
          .catch(() => {})
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/styles/common.scss';

.container-info {
  position: relative;
}
</style>
